// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"0523e48d","513":"10d85eed","703":"b12fa6e0","787":"7325d68a"}[chunkId] + ".chunk.js";
};